import { all, put, takeLatest, call } from 'redux-saga/effects';
import { RegActionTypes } from './types';
import {
  fetchRegError,
  fetchRegSuccess,
  fetchRegConfirmationSuccess,
  fetchRegConfirmationError
} from './action';
import Services from '../../services';
import {
  RegistrationDataTypes,
  ConfirmationDataTypes,
  LoginCredentials,
  API_STATUS,
  AUTH_TYPE
} from 'types';
import { setUserName, setIsUserReg } from 'redux/session/actions';
import { fetchAuthRequest } from 'redux/auth/action';

function* handleFetch(request: any) {
  const regPayload: RegistrationDataTypes = request.payload;
  try {
    const res = yield call(Services.auth.userRegistration, regPayload);
    if (!res.errors) {
      yield put(fetchRegSuccess(res));
      yield put(setUserName(res.user.username));
      yield put(setIsUserReg(true));
    }
  } catch (error) {
    yield put(fetchRegError(error.message));
  }
}
function* watchFetchRequest() {
  yield takeLatest(RegActionTypes.FETCH_REG_REQUEST, handleFetch);
}

function* handleFetchRegConfirmation(request: any) {
  const { username, confirmationCode, password } = request.payload;

  const loginPayload: LoginCredentials = {
    username: username,
    password
  };

  const regConfirmationPayload: ConfirmationDataTypes = {
    username,
    confirmationCode
  };
  try {
    const res = yield call(
      Services.auth.userConfirmRegistration,
      regConfirmationPayload
    );
    if (!res.errors || res === API_STATUS.SUCCESS) {
      yield put(fetchRegConfirmationSuccess(res));
      yield put(
        fetchAuthRequest({
          values: loginPayload,
          context: AUTH_TYPE.BASIC_LOGIN
        })
      );
    } else {
      yield put(fetchRegConfirmationError(res.errors));
    }
  } catch (error) {
    yield put(fetchRegConfirmationError(error.message));
  }
}
function* watchFetchRequestRegConfirmation() {
  yield takeLatest(
    RegActionTypes.FETCH_REG_CONFIRMATION_REQUEST,
    handleFetchRegConfirmation
  );
}

function* regSagas() {
  yield all([call(watchFetchRequest), call(watchFetchRequestRegConfirmation)]);
}
export default regSagas;
